import { useState } from 'react'
import RoutesMap from 'route_control/RouteControl'
import { Form, InputGroup, Button, Card } from 'react-bootstrap'
import { useFormik } from 'formik'
import { KeyRound, UserRound, Eye, EyeOff, Smartphone } from 'lucide-react'
import { toast } from 'react-toastify'
import logo from 'assets/images/express-logo-full.png'
import { LoginSchema } from './ValidationSchema'
import { ButtonLoader } from 'components/loader'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { signIn } from '../../../redux/slices/assets'
import { SessionManager, TOKEN_COOKIE, USER_COOKIE } from 'utils'

export default function UserLoginForm(props) {

  const { setTogggle, onPhoneLogin } = props

  const [spinner, setSpinner] = useState(false)
  const [showPassword, setShowPassword] = useState(false)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const initialValues = {
    username: '',
    password: '',
  };

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
    initialValues: initialValues,
    validationSchema: LoginSchema,

    onSubmit: (values, action) => {
      // console.log(values)
      setSpinner(true)
      dispatch(signIn(values)).then((res) => signIn_user(res.payload, action))
    },
  })

  // Portal login: 200 => { userId, accessToken: "Bearer ..." }, 401 => { message: "Login Failed" }
  const signIn_user = (res, action) => {

    if (res?.status === 200 && res?.data?.status === 200 && res?.data?.accessToken) {
      SessionManager.setCookie(TOKEN_COOKIE, res.data.accessToken, 24)
      SessionManager.setCookie(USER_COOKIE, JSON.stringify({ userId: res.data.userId, userName: values.username }), 24)
      navigate(RoutesMap.DASHBOARD.path)
      toast.success(res?.data?.message || "Login Success", { position: "bottom-right" })
    } else if (res?.status === 401 || res?.status === 400) {
      setSpinner(false)
      toast.error(res?.data?.message || "Login Failed", { position: "bottom-right" })
    } else if (res?.status === 500) {
      setSpinner(false)
      toast.error("Server error!!..", { position: "bottom-right" })
    } else {
      setSpinner(false)
      toast.error("Something went wrong!!..", { position: "bottom-right" })
    }
  }

  return (
    <Card className="h-100 border-0 shadow" style={{ borderRadius: '16px', backgroundColor: '#ffffff', overflow: 'hidden' }}>
      <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} className='h-100 d-flex flex-column'>

        <div className="text-end px-4 pt-3 pb-2">
          <u className='fw-medium text-muted' style={{ cursor: 'pointer', fontSize: '13px', textDecorationColor: '#006972' }} onClick={() => setTogggle(true)}>Forgot Password?</u>
        </div>

        <Card.Body className='px-4 px-sm-5 d-flex flex-column justify-content-center'>
          <div className='text-center mb-2'>
            <img src={logo} alt="logo" className='img-fluid mb-2' style={{ height: '60px', objectFit: 'contain' }} />
            <h4 className='fw-bold mb-1' style={{ color: '#001529' }}>Customer Login</h4>
            <p className="text-muted" style={{ fontSize: '14px' }}>Welcome back! Please enter your details.</p>
          </div>

          <div className='mb-1'>
            <Form.Label className='fw-semibold mb-1 text-dark' style={{ fontSize: '13px' }}>Username</Form.Label>
            <InputGroup
              className="rounded-3 shadow-sm"
              style={{ border: '1px solid #e1e5eb', overflow: 'hidden', backgroundColor: '#f9fafb' }}
            >
              <InputGroup.Text id="username" className="bg-transparent border-0 text-muted px-3">
                <UserRound size={18} strokeWidth={2} />
              </InputGroup.Text>
              <Form.Control
                className='login-input border-0 bg-transparent shadow-none px-0'
                placeholder="Enter your username"
                aria-label="Username"
                aria-describedby="username"
                name='username'
                value={values.username || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                style={{ fontSize: '14px', height: '45px' }}
              />
            </InputGroup>
            {errors.username && touched.username ? (<div className='text-danger mt-1 ms-1' style={{ fontSize: '12px' }}>{errors.username}</div>) : null}
          </div>

          <div className='mb-1'>
            <Form.Label className='fw-semibold mb-1 text-dark' style={{ fontSize: '13px' }}>Password</Form.Label>
            <InputGroup
              className="rounded-3 shadow-sm"
              style={{ border: '1px solid #e1e5eb', overflow: 'hidden', backgroundColor: '#f9fafb' }}
            >
              <InputGroup.Text id="password" className="bg-transparent border-0 text-muted px-3">
                <KeyRound size={18} strokeWidth={2} />
              </InputGroup.Text>
              <Form.Control
                type={showPassword ? 'text' : 'password'}
                className='login-input border-0 bg-transparent shadow-none px-0'
                placeholder="Enter your password"
                aria-label="Password"
                aria-describedby="password"
                name='password'
                value={values.password || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                style={{ fontSize: '14px', height: '45px' }}
              />
              <InputGroup.Text
                id="password"
                onClick={() => setShowPassword(!showPassword)}
                className="bg-transparent border-0 text-muted px-3"
                style={{ cursor: 'pointer' }}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </InputGroup.Text>
            </InputGroup>
            {errors.password && touched.password ? (<div className='text-danger mt-1 ms-1' style={{ fontSize: '12px' }}>{errors.password}</div>) : null}
          </div>

          <div className="mt-2 text-center">
            <Button type='submit' className='w-100 login_save_btn shadow text-uppercase fw-bold rounded-3' style={{ letterSpacing: '1px' }} disabled={spinner}>
              {spinner ? <ButtonLoader /> : 'Login'}
            </Button>
            {onPhoneLogin &&
              <>
                <div className="login_or"><span>OR</span></div>
                <Button type='button' variant='light' className='w-100 phone_login_btn rounded-3 fw-semibold' onClick={onPhoneLogin} disabled={spinner}>
                  <Smartphone size={16} /> Login Via Phone No.
                </Button>
              </>
            }
          </div>
        </Card.Body>


      </Form>
    </Card>
  )
}